import React, { useCallback } from 'react';
import Modal, { IModalProps } from './Modal';
import { useServer } from 'utils/hooks/useServer';

export interface IClosableModal extends Omit<IModalProps, 'container'> {
  closeModal: () => void;
  show: boolean;
}

const ClosableModal: React.FC<IClosableModal> = ({ onClose, onOpen, children, closeModal, show, ...other }) => {
  const isServer = useServer();
  const escFunction = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeModal && closeModal();
        document.removeEventListener('keydown', escFunction, false);
      }
    },
    [closeModal]
  );

  const onOpenHandler = useCallback(() => {
    if (onOpen) onOpen();
    document.addEventListener('keydown', escFunction, false);
  }, [escFunction, onOpen]);

  const onCloseHandler = useCallback(() => {
    if (onClose) onClose();
    document.removeEventListener('keydown', escFunction, false);
  }, [escFunction, onClose]);

  return !isServer ? (
    <Modal
      show={show}
      onClick={closeModal}
      onOpen={onOpenHandler}
      onClose={onCloseHandler}
      container={document.getElementById('portal-root') as HTMLElement}
      {...other}
    >
      {children}
    </Modal>
  ) : null;
};

export default ClosableModal;
